import { Observable, of } from 'rxjs';

class SessionStorageProvider {
  get(name: string): Observable<string | null | undefined> {
    return of(sessionStorage.getItem(name));
  }
  set(name: string, value: string): void {
    sessionStorage.setItem(name, value);
  }
  remove(name: string): void {
    sessionStorage.removeItem(name);
  }
}
export default SessionStorageProvider;
